import { gql, TypedDocumentNode } from '@apollo/client'
import { QueryPageableRequest, QueryPageableResponse } from '../../../core/type'
import { Contact } from '../../contact/type/contact'
import {
    PurchaseOrder,
    PurchaseOrderCalculationRequest,
    PurchaseOrderCalculationReviewResponse,
    PurchaseOrderFindMaxItemsRequest,
    PurchaseOrderFindMinMaxItemsResponse,
    PurchaseOrderFindOrdersRequest,
    PurchaseOrderFindOrdersResponse, PurchaseOrderParcelDeliveryInput, PurchaseOrderRequest, PurchaseOrderUpdateInput,
    PurchaseOrderVendorRequest
} from '../type/purchase-order'

export const PurchaseOrderFindVendorsQuery: TypedDocumentNode<QueryPageableResponse<Contact, 'purchaseOrderFindVendors'>, QueryPageableRequest<PurchaseOrderVendorRequest>> = gql`
    query PurchaseOrderFindVendorsQuery($request: PurchaseOrderVendorRequest!) {
        purchaseOrderFindVendors(request: $request) {
            data {
                id
                contactId
                company
            }
        }
    }
`

export const PurchaseOrderFindOrdersQuery: TypedDocumentNode<
    QueryPageableResponse<PurchaseOrderFindOrdersResponse, 'purchaseOrderFindOrders', {quantityCount: number}>,
    QueryPageableRequest<PurchaseOrderFindOrdersRequest>> = gql`
    query PurchaseOrderFindOrdersQuery($request: PurchaseOrderFindOrdersRequest!) {
        purchaseOrderFindOrders(request: $request) {
            data {
                id
                number
                date
                vendor {
                    contactId
                }
                category {
                    title
                }
                item {
                    sku
                    description
                    style
                }
                backOrderQuantity
                allocatedPurchaseOrderNumber
            }
            count
            quantityCount
        }
    }
`

export const PurchaseOrderMinMaxItemsQuery: TypedDocumentNode<
    QueryPageableResponse<PurchaseOrderFindMinMaxItemsResponse, 'purchaseOrderMinMaxItems'>,
    QueryPageableRequest<PurchaseOrderFindMaxItemsRequest>
> = gql`
    query PurchaseOrderMinMaxItemsQuery($request: PurchaseOrderFindMinMaxItemsRequest!) {
        purchaseOrderMinMaxItems(request: $request) {
            data {
                id
                sku
                description
                vendor
                inStock
                min
                max
                quantityNeeded
                productCategory
            }
            count
        }
    }
`

export const PurchaseOrderCalculationReviewQuery: TypedDocumentNode<{
    purchaseOrderCalculationReview: PurchaseOrderCalculationReviewResponse[]
}, { request: PurchaseOrderCalculationRequest }> = gql`
    query PurchaseOrderCalculationReviewQuery($request: PurchaseOrderCalculationRequest!) {
        purchaseOrderCalculationReview(request: $request) {
            vendor {
                id
                contactId
            }
            total
            items {
                item {
                    id
                    sku
                    description
                }
                vendor {
                    id
                    contactId
                }
                quantity
                price
                source
            }
        }
    }
`

export const PurchaseOrderGenerate: TypedDocumentNode<{ purchaseOrderGenerate: number[] }, {
    input: PurchaseOrderCalculationRequest
}> = gql`
    mutation PurchaseOrderGenerate($input: PurchaseOrderCalculationRequest!) {
        purchaseOrderGenerate(input: $input)
    }
`

export const PurchaseOrderQuery: TypedDocumentNode<QueryPageableResponse<PurchaseOrder, 'purchaseOrdersFind'>, QueryPageableRequest<PurchaseOrderRequest>> = gql`
    query PurchaseOrderQuery($request: PurchaseOrderRequest!) {
        purchaseOrdersFind(request: $request) {
            data {
                createdAt
                id
                number
                date
                note
                showNote
                status
                type
                vendor {
                    contactId
                    accountNumber
                    phones {
                        type
                        number
                    }
                    addresses {
                        street
                        city
                        state
                        zipCode
                    }
                    webInfos {
                        type
                        value
                    }
                }
                items {
                    id
                    item {
                        id
                        sku
                        description
                        style
                    }
                    quantity
                    quantityReceived
                    price
                    description
                    source
                }
                parcelDelivery {
                    date
                    items {
                        item {
                            id
                            sku
                            description
                        }
                        quantity
                        costPrice
                    }
                }
                backOrders {
                    orderLine {
                        itemId
                        order {
                            number
                        }
                    }
                }
            }
            count
        }
    }
`

export const PurchaseOrderListQuery: TypedDocumentNode<QueryPageableResponse<PurchaseOrder, 'purchaseOrdersFind'>, QueryPageableRequest<PurchaseOrderRequest>> = gql`
    query PurchaseOrderListQuery($request: PurchaseOrderRequest!) {
        purchaseOrdersFind(request: $request) {
            data {
                id
                number
                date
                createdAt
                status
                vendor {
                    contactId
                    company
                }
                items {
                    id
                    quantity
                    quantityReceived
                    price
                    source
                }
            }
            count
        }
    }
`

export const PurchaseOrderUpdate: TypedDocumentNode<void, { input: PurchaseOrderUpdateInput }> = gql`
    mutation PurchaseOrderUpdate($input: PurchaseOrderUpdateInput!) {
        purchaseOrderUpdate(input: $input)
    }
`

export const PurchaseOrderDelete: TypedDocumentNode<void, {id: number}> = gql`
    mutation PurchaseOrderDelete ($id: Int!) {
        purchaseOrderDelete(id: $id)
    }
`

export const PurchaseOrderConfirm: TypedDocumentNode<void, { id: number }> = gql`
    mutation PurchaseOrderUpdate($id: Int!) {
        purchaseOrderConfirm(id: $id)
    }
`

export const PurchaseOrderCreateParcelDelivery: TypedDocumentNode<void, {input: PurchaseOrderParcelDeliveryInput}> = gql`
    mutation PurchaseOrderCreateParcelDelivery($input: PurchaseOrderParcelDeliveryCreateInput!) {
        purchaseOrderCreateParcelDelivery(input: $input)
    }
`
